import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=4a7da462&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7da462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7da462')) {
      api.createRecord('4a7da462', component.options)
    } else {
      api.reload('4a7da462', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=4a7da462&scoped=true&", function () {
      api.rerender('4a7da462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U6Kxhn3ADqJo/JS/comp/Voucher-Unit.vue"
export default component.exports